Ext.define('SA.view.sidebar.data.Attribute', {
    alias: 'widget.attribute',
    extend: 'Ext.Component',

    cls: 'sa-attribute',

    tpl: [
        '<div class="sa-attribute-body">',
            '<span class="sa-attribute-name">{name:htmlEncode}</span>',
            '<span class="sa-attribute-check-wrap" title="Added to project">',
                '<svg class="sa-attribute-check">',
                    '<use href="#sa-icon-check-mark"></use>',
                '</svg>',
            '</span>',
        '</div>',
        '<div class="sa-attribute-menu-button">',
            '<div class="sa-attribute-menu-button-dot"></div>',
            '<div class="sa-attribute-menu-button-dot"></div>',
            '<div class="sa-attribute-menu-button-dot"></div>',
        '</div>'
    ],

    initComponent() {
        this.callParent();

        this.ifCls(this.selected, 'sa-attribute-selected');
        this.update({name: this.name});
    },

    getMenu() {
        return Ext.widget({
            xtype: 'menu',
            defaults: {attribute: this.attribute},
            getRefOwner: () => this,
            plugins: [{ptype: 'sa-arrow', target: this.getMenuButtonEl()}],
            track: true,

            items: [
                {
                    text: 'Use this Data Variable',
                    handler: () => this.onSelected()
                }, {
                    xtype: 'menu-add-remove-favorite-attribute'
                }, {
                    xtype: 'menu-view-attribute-metadata'
                }
            ]
        });
    },

    getMenuButtonEl() {
        return this.el.down('.sa-attribute-menu-button');
    },

    initEvents() {
        this.callParent();

        this.el.on('click', this.onSelected, this, {delegate: '.sa-attribute-body'});
        this.el.on('click', this.onMenuButtonClick, this, {delegate: '.sa-attribute-menu-button'});
    },

    onMenuButtonClick(ev, buttonEl) {
        if (this.menu && this.menu.wasRecentlyVisible()) {
            return;
        }

        this.setHasOpenMenu(true);

        this.menu = this.getMenu();
        this.menu.on('hide', () => this.setHasOpenMenu(false));
        this.menu.showBy(buttonEl, 'tr-br?', [0, 7]);
    },

    onSelected() {
        this.fireEvent('select', this.attribute);
    },

    setFilter(filter) {
        this.setVisible(filter(this.name));
    },

    setHasOpenMenu(hasOpenMenu) {
        this.getMenuButtonEl().ifCls(hasOpenMenu, 'sa-attribute-menu-button-open');
    },

    setSelected(selected) {
        this.ifCls(selected, 'sa-attribute-selected');
    }
});
